export enum ParentRight {
  DEV = 'ROLE_API_DEV',
  SUPER_ADMIN = 'ROLE_API_SUPER_ADMIN',
  ADMIN = 'ROLE_API_ADMIN',
  USER = 'ROLE_API_USER',
}
